(() => {
  if (customElements.get('dw-shapewear-kit')) return;
  class Kit extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.form = this.closest('form') || document.getElementById(this.dataset.formId);
      this.rows = [...this.querySelectorAll('[data-kit-item]')].map(row => ({
        el:row, data:row.querySelector('[data-kit-product]') ? JSON.parse(row.querySelector('[data-kit-product]').textContent) : null,
        selects:[...row.querySelectorAll('select')], manual:false
      }));
      this.rows.forEach((row,index) => row.selects.forEach(select => select.addEventListener('change',event => {
        event.stopPropagation();
        if (/^size$/i.test(select.dataset.optionName)) {
          if (index === 0) this.syncSize(); else row.manual = true;
        }
        this.validate();
        this.updateGallery(row);
      })));
      this.ready = true; this.syncSize(); this.validate();
    }
    updateGallery(row) {
      const variant = row.data?.variants.find(v => row.selects.every(select => v.options[Number(select.dataset.optionIndex)] === select.value));
      if (!variant?.image) return;
      const gallery = this.closest('.shopify-section')?.querySelector('#all-product-images[data-shared-gallery]') || document.querySelector('#all-product-images[data-shared-gallery]');
      const main = gallery?.querySelector('.main-image-slider');
      const thumbs = gallery?.querySelector('.thumbnail-slider');
      if (!main) return;
      const slide = main.querySelector('.main-slide:not(.slick-cloned)');
      const image = slide?.querySelector('img');
      if (!image) return;
      image.removeAttribute('srcset'); image.removeAttribute('sizes');
      const gallerySource = new URL(variant.image, location.origin);
      gallerySource.searchParams.delete('height');
      gallerySource.searchParams.delete('crop');
      gallerySource.searchParams.set('width', '1600');
      image.src = gallerySource.href;
      image.srcset = [640, 960, 1440, 1920].map(width => {
        const candidate = new URL(gallerySource.href);
        candidate.searchParams.set('width', String(width));
        return candidate.href + ' ' + width + 'w';
      }).join(', ');
      image.sizes = '(max-width: 760px) 100vw, 50vw';
      image.alt = row.el.querySelector('legend')?.textContent.trim() || 'Selected kit item';
      const thumb = thumbs?.querySelector('.thumb-slide:not(.slick-cloned) img');
      if (thumb) { thumb.removeAttribute('srcset'); thumb.src = variant.image; thumb.alt = image.alt; }
      if (window.jQuery?.fn?.slick && main.classList.contains('slick-initialized')) {
        window.jQuery(main).slick('slickGoTo', 0);
        image.addEventListener('load', () => {
          if (main.classList.contains('slick-initialized')) window.jQuery(main).slick('setPosition');
        }, {once:true});
      }
    }
    syncSize() {
      const size = this.rows[0]?.selects.find(select => /^size$/i.test(select.dataset.optionName))?.value;
      if (!size) return;
      this.rows.slice(1).forEach(row => {
        const select = row.selects.find(select => /^size$/i.test(select.dataset.optionName));
        if (!select || row.manual) return;
        if (![...select.options].some(option => option.value === size)) {
          const option = new Option(size + ' — Unavailable',size); select.add(option);
        }
        select.value = size;
      });
    }
    validate() {
      let error = '';
      this.rows.forEach(row => {
        const variant = row.data?.variants.find(variant => row.selects.every(select => variant.options[Number(select.dataset.optionIndex)] === select.value));
        row.selects.forEach(select => select.setAttribute('aria-invalid',String(!variant)));
        if (!variant) error = 'Please choose a valid colour and size for each of the three kit items.';
        const image = row.el.querySelector('img');
        if (image && variant?.image) { image.removeAttribute('srcset'); image.src = variant.image; }
      });
      if (this.rows.length !== 3) error = 'This kit is not fully configured. Please contact us before ordering.';
      const message = this.querySelector('[data-kit-error]'); message.textContent = error; message.hidden = !error;
      return !error;
    }
  }
  customElements.define('dw-shapewear-kit',Kit);
  document.addEventListener('submit',event => {
    const kit = event.target.querySelector?.('dw-shapewear-kit') || [...document.querySelectorAll('dw-shapewear-kit')].find(item => item.form === event.target);
    if (kit && (!kit.ready || !kit.validate())) { event.preventDefault(); event.stopImmediatePropagation(); kit.querySelector('[aria-invalid="true"]')?.focus(); }
  },true);
})();
